export const AUTH_INITIATE = "AUTH_INITIATE";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const MESSAGE_FETCHING = "MESSAGE_FETCHING";
export const MESSAGE_FETCHING_SUCCESSFULLY = "MESSAGE_FETCHING_SUCCESSFULLY";
export const MESSAGE_DELETING = "MESSAGE_DELETING";
export const MESSAGE_DELETING_SUCCESSFULLY = "MESSAGE_DELETING_SUCCESSFULLY";
